// extracted by mini-css-extract-plugin
module.exports = {"bgGrey":"TemplateMonitorGlobalStyles_bgGrey__2r-ZR","opScopeWidth":"TemplateMonitorGlobalStyles_opScopeWidth__cdIz6","tooltip":"TemplateMonitorGlobalStyles_tooltip__3LZhI"};